import { useEffect, useRef, useState } from 'react';

export interface ShareDialogProps {
  routeId: string;
  onClose: () => void;
}

export function ShareDialog({ routeId, onClose }: ShareDialogProps) {
  const url = `${window.location.origin}/r/${routeId}`;
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.select();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard blocked (insecure context, or permission denied). The input is
      // already selected, so ⌘C still works.
      inputRef.current?.select();
    }
  }

  return (
    <div className="backdrop" onClick={onClose} role="presentation">
      <div className="dialog" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
        <h2>Route saved</h2>
        <p>Send this to the group. It opens in the app on a phone, or on the web anywhere else.</p>
        <div className="share-row">
          <input ref={inputRef} readOnly value={url} onFocus={(event) => event.target.select()} />
          <button type="button" onClick={copy}>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
        <p className="fine-print">
          Anyone with the link can view the route and open it in the app. Editing it needs a sign-in;
          it will be waiting under Saved routes.
        </p>
        <div className="dialog-actions">
          <a className="link-button" href={`/api/routes/${routeId}/gpx`}>
            Download GPX
          </a>
          <button type="button" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
